// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"user-safety"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M16 7.5C16 9.98528 13.9853 12 11.5 12C9.01472 12 7 9.98528 7 7.5C7 5.01472 9.01472 3 11.5 3C13.9853 3 16 5.01472 16 7.5Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M15.5 14.5C17.8954 14.5 20.1046 14.5 22.5 14.5V19.1336C22.5 19.8089 22.1592 20.4387 21.5938 20.808L19 22.5024L16.4062 20.808C15.8408 20.4387 15.5 19.8089 15.5 19.1336V14.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M11.5 15H8C5.23858 15 3 17.2386 3 20V21H11.5508M16 7.5C16 9.98528 13.9853 12 11.5 12C9.01472 12 7 9.98528 7 7.5C7 5.01472 9.01472 3 11.5 3C13.9853 3 16 5.01472 16 7.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M15.5 14.5C17.8954 14.5 20.1046 14.5 22.5 14.5V19.1336C22.5 19.8089 22.1592 20.4387 21.5938 20.808L19 22.5024L16.4062 20.808C15.8408 20.4387 15.5 19.8089 15.5 19.1336V14.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const UserSafetyIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'user-safety',
    ref,
    icon: element,
  },
));

UserSafetyIcon.displayName = 'UserSafetyIcon';

export default UserSafetyIcon;
